export default {
  templateId: 'accordian-2',
  title: 'Product Title',
  subtitle: 'Product Subtitle',
};
